'use strict';

export default class Focus {
    inserted(el: HTMLElement) {
        el.focus();
    }
}
